import React from 'react';
import { Stack, Typography } from '@mui/material';
import { DashboardButtonStyled } from './dashboard-action-item.styled';

type DashboardActionItemProps = {
  title: string;
  icon: React.ReactNode;
  onClick?: () => void;
  color?: string;
};

export const DashboardActionItem: React.FC<DashboardActionItemProps> = ({ title, icon, onClick, color }) => (
  <DashboardButtonStyled backgroundColor={color} {...(onClick ? { onClick } : { sx: { pointerEvents: 'none' } })}>
    <Stack alignItems="flex-start">
      <Stack justifyContent="center" sx={{ height: '40px' }} marginBottom={2}>
        {icon}
      </Stack>
      <Typography minHeight={42} {...(color && { color: '#fff' })}>
        {title}
      </Typography>
    </Stack>
  </DashboardButtonStyled>
);
